module.exports = __webpack_public_path__ + "static/media/joshua-prof.c065e52b.svg";